import { render, staticRenderFns } from "./FooterUNILIDER.vue?vue&type=template&id=cc6ecc9a&scoped=true"
import script from "./FooterUNILIDER.vue?vue&type=script&lang=js"
export * from "./FooterUNILIDER.vue?vue&type=script&lang=js"
import style0 from "./FooterUNILIDER.vue?vue&type=style&index=0&id=cc6ecc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6ecc9a",
  null
  
)

export default component.exports